export enum FeatureSlugsEnum {
  ACTORS = "actors",
  AGENTS = "agents",
  AGENTS_DEV_MODE = "agents_dev_mode",
  API_DOCS = "api_docs",
  AUTOMATIONS = "automations",
  BATCH_UPDATE_PROCESSES = "batch_update_processes",
  BOOKING_QUOTATION = "booking_quotation",
  COSTS = "processes_costs",
  CREDENTIALS = "credentials",
  DASHBOARD = "dashboards",
  DRIVERS = "drivers",
  FLOWLS_AI = "flowls_ai",
  FLOWLS_AI_INTEGRATIONS = "flowls_ai_integrations",
  GLOBAL_TRACKING = "global_tracking",
  INSIGHTS = "insights",
  INTEGRATION_LOGS = "integration_logs",
  LEAD_TIMES = "lead_times",
  LPCO = "lpco",
  MERCANTE = "mercante",
  NOTIFICATION_GROUPS = "notification_groups",
  ORDER_PDFS = "order_pdfs",
  PORT_TERMINALS = "port_terminals",
  PROCESS_INSIGHTS = "process_insights",
  PROCESS_VERSIONS = "process_versions",
  PRODUCTS = "products",
  PRODUCTS_C9_RATIO = "products_c9_ratio",
  ROUTES = "routes",
  TRAILERS = "trailers",
  USERS = "users",
  VEHICLES = "vehicles",
  WORKSPACES = "workspaces",
}
